import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getMultilineText } from '../../../../../general/js/utils';

function TheOneClubIntro({ text, imageSource, imageText }) {
    const texts = getMultilineText(text);
    return (
        <div className='join-the-club'>
            <div className='text'>
                {texts.map((introText) => {
                    return <p key={_.uniqueId()}>{introText}</p>;
                })}
            </div>
            <div className='form'>
                <div className='image image--titled'>
                    <img className='image__img lazyautosizes lazyloaded'
                        data-sizes='auto'
                        alt=''
                        sizes='499px'
                        srcSet={imageSource}>
                    </img>
                </div>
                <p>{imageText}</p>
            </div>
        </div >
    );
}

TheOneClubIntro.propTypes = {
    text: PropTypes.string.isRequired,
    imageSource: PropTypes.string.isRequired,
    imageText: PropTypes.string.isRequired
};

export default TheOneClubIntro;
